import React from 'react';
import styles from './TabItem.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const TabItem = ({
  tabName,
  displayName,
  activeTab,
  onClick
}) => {
  return (
    <li
      className={cx('TabItem', (tabName === activeTab && 'active'))}
      onClick={() => onClick(tabName)}
    >
      {displayName}
    </li>
  );
};

export default TabItem;


// WEBPACK FOOTER //
// ./src/app/components/atoms/TabItem/TabItem.js